export default "__VITE_ASSET__jQ1vNRE7__"